import PropTypes from 'prop-types';


export default {
  containerAlign: PropTypes.string.isRequired,
  isCenterAlign: PropTypes.bool.isRequired,
  darkFontVersion: PropTypes.bool.isRequired,
  imgUrl: PropTypes.arrayOf(PropTypes.shape({
    imgs: PropTypes.arrayOf(PropTypes.shape({
      density: PropTypes.number,
      url: PropTypes.string
    })),
    width: PropTypes.number
  })).isRequired,
  altText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  buttons: PropTypes.arrayOf(PropTypes.shape({
    altText: PropTypes.string,
    img: PropTypes.arrayOf(Object),
    lightBgColor: PropTypes.bool,
    linkTitle: PropTypes.string,
    text: PropTypes.string,
    url: PropTypes.string
  })).isRequired,
  slideDesktop: PropTypes.shape({
    buttons: PropTypes.arrayOf(PropTypes.shape({
      altText: PropTypes.string,
      img: PropTypes.arrayOf(Object),
      lightBgColor: PropTypes.bool,
      linkTitle: PropTypes.string,
      text: PropTypes.string,
      url: PropTypes.string
    })),
    isCenterAlignDesktop: PropTypes.bool,
    subtitle: PropTypes.string,
    title: PropTypes.string
  }).isRequired
};
